import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvService {
  // The values that are defined here are the default values that can
  // be overridden by env.js

  // API url
  public servicePath = 'http://mybiz6-lite.mybiz.net/AppService/AppService.svc/';
  public showAppVersion = true;
  public loginBackdrop = "../../assets/images/business-1-dark.jpg";
  public supplierBackdrop = '../../assets/images/business-1.jpg';
  public portalTitle = "MyBiz eProcurement Portal";
  public portalTab = "MyBiz Lite Dev";
  public portalName = 'MyBiz';
  public userGuidesHtml = "WelcometoMyBizeProcurementPortal.html";
  public allowRegistration = "Register As Supplier";
  public allowContactUs = "Contact Us";
  public allowSupplierApplication = '';
  public headersOrder = ['allowSupplierApplication', 'allowContactUs'];
  public supplierHeaderText = '<h2>MYBIZ SUPPLIER NETWORK</h2><p>Connect. Grow.</p>';
  public primaryColor = '#007BC4';
  public secondaryColor = '#EDF7FD';
  public accentColor = '#4A98DC';
  public baseColor = '#f8f8f8';
  public iconColor = '#495057';
  public enableCaptcha = false;
  public sessionTimeout = 15;
  public checkIntervalUpdate = 5;
  public shortHeader = false;
  public chartExpand = false;
  public showLoginTerms = false;
  public footerText = "Copyright © 2019 MyBiz Solutions Sdn Bhd. All rights reserved";
  public captchaKey = "6Ld9260UAAAAAI6QMMrnC8NM7fNLSdemJoAVMlfZ";
  // public captchaKey = "6Lc-ovYUAAAAAMFQkb1XcRuuBbTlvEUX4p0FlhFf";
  
  // Whether or not to enable debug mode
  public enableDebug = true;

  constructor() {
  }
}
